<template>
  <section :ref="`_$root`" :class="classnames">
    <ul class="dashboard-tile__list">
      <template v-for="(dashboard, index) in dashboards">
        
        <template v-if="index < tileLimit">
          <product-dashboard-item :item="dashboard" :key="index" />
        </template>
        <template v-else-if="index === tileLimit">
          <li class="dashboard-tile__item dashboard-tile__item--toggle" :key="index">
            <vue-button :appearance="`large`" @click="handleToggleButtonClick">
              <template slot="text">
                {{ `${moreRevealed ? 'Less' : 'More'}` }}
              </template>
            </vue-button>
          </li>
        </template>
        <template v-else>
          <product-dashboard-item :hide="true" :item="dashboard" :key="index" />
        </template>
      </template>
        <template v-if="moreRevealed">
          <li class="dashboard-tile__item dashboard-tile__item--toggle" key="__index">
            <vue-button :appearance="`large`" @click="handleToggleButtonClick">
              <template slot="text">
                {{ `${moreRevealed ? 'Less' : 'More'}` }}
              </template>
            </vue-button>
          </li>
        </template>

    </ul>
  </section>
</template>

<script>
  import ProductDashboardItem from '@/components/ProductDashboardItem'
  import VueButton from '@/components/VueButton'

  import { bem } from '@/mixins/bem.js'
  import { helpers } from '@/mixins/helpers.js'

  const namespace = 'product-dashboard'

  export default {
    name: 'ProductDashboard',
    components: {
      'product-dashboard-item': ProductDashboardItem,
      'vue-button': VueButton
    },
    mixins: [ bem, helpers ],
    props: {
      dashboards: {
        default: function () {
          return []
        },
        type: Array
      }
    },
    data: function () {
      return {
        isDesktop: true,
        moreRevealed: false,
        tileLimit: 0,
        windowResizeListener: null
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    mounted: function () {
      this.setTileLimit()

      this.windowResizeListener = addEventListener('resize', this.handleWindowResize)
    },
    beforeDestroy: function () {
      removeEventListener('resize', this.windowResizeListener)
    },
    methods: {
      setTileLimit: function () {
        if (!this.moreRevealed) {
          const winW = window.innerWidth
          const winH = window.innerHeight
          if (winW <= 375) {
            this.tileLimit = 5
          } else if (winW < 768) {
            this.tileLimit = 5
          } else if (winW < 1024) {
            this.tileLimit = 7
          } else if (winW === 768 && winH === 1024) {
            this.tileLimit = 4
          } else if (winW <= 1400) {
            this.tileLimit = 4
          } else if (winW < 1440) {
            this.tileLimit = 7
          } else if (winW === 1440) {
            this.tileLimit = 7
          } else if (winW < 2600) {
            this.tileLimit = 7
          } else {
            this.tileLimit = 6
          }
        }
      },
      classnameModifiers: function () {
        const isDesktop = this.isDesktop && 'desktop'
        const moreRevealed = this.moreRevealed ? 'more' : 'less'

        return [
          isDesktop,
          moreRevealed
        ]
      },

      disableToggleButton: function () {
        const {
          dashboards
        } = this

        this.isDesktop = false
        this.tileLimit = dashboards.length
      },
      getWindowWidth: function () {
        const width = document.documentElement.clientWidth

        return width
      },
      handleToggleButtonClick: function () {
        if (this.moreRevealed) {
          this.showLessTiles()
        } else {
          this.showMoreTiles()
        }
      },
      handleWindowResize: function () {
        this.setTileLimit()
      },
      showLessTiles: function () {
        this.moreRevealed = false
        this.setTileLimit()
      },
      showMoreTiles: function () {
        const {
          dashboards
        } = this

        this.tileLimit = dashboards.length + 1
        this.moreRevealed = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ProductDashboard.vue